import { render, staticRenderFns } from "./OperadorasDataTable.vue?vue&type=template&id=6bdebb28"
import script from "./OperadorasDataTable.vue?vue&type=script&lang=ts"
export * from "./OperadorasDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports